import { combineReducers } from 'redux';
import products from './product-reducer';
import productSingle from './product-single-reducer';
import users from './user-reducer';
import reservations from './reservation-reducer';
import groups from './group-reducer';
import payments from './payment-reducer';
import clients from './client-reducer';
import orders from './order-reducer';
import travels from './travel-reducer';
import locations from './location-reducer';
import reverseOrders from './reverse-order-reducer';
import routings from './routing-reducer';
import routingDetail from './routing-detail-reducer';
import groupedPayments from './grouped-payment-reducer';
import notifications from './notification-reducer';
import contracts from './contract-reducer';
import countries from './country-reducer';
import labelAddress from './label-address-reducer';
import incidents from './incident-reducer';
import paymentsDelivery from './payment-delivery-reducer';
import productAudit from './product-audit-reducer';
import groupAudit from './group-audit-reducer';
import resetGroupAudit from './reset-group-audit-reducer';
import resourcesDriverUser from './resources-driver-user-reducer';

export default combineReducers({
  products,
  users,
  reservations,
  groups,
  productSingle,
  payments,
  clients,
  orders,
  travels,
  locations,
  reverseOrders,
  routings,
  routingDetail,
  groupedPayments,
  notifications,
  contracts,
  countries,
  labelAddress,
  incidents,
  paymentsDelivery,
  productAudit,
  groupAudit,
  resetGroupAudit,
  resourcesDriverUser
});
